import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { DynamicForm } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import TablaGuiasEmbarque from './TablaGuiasEmbarque'
import { Button, CircularProgress } from '@material-ui/core';
import SubirProductos from "../../../components/SubirProductos";
import Toast from 'react-hot-toast';

class EmbarqueCartaPorteDatos extends Component {
  idEmbarque = this.props.idEmbarque;
  state = {
    loadingData: true,
    FormData: new Form([
      Form.Section('Chofer'),
      Form.Field('autocomplete-async', 'id_chofer', 'Buscar Chofer', '', [Validators.required], 12, [], [], [], false, false, '', 'search/operador'),
      Form.Field('text', 'chofer_numero_licencia', 'Licencia Chofer', '', [Validators.required], 6),
      Form.Field('text', 'chofer_rfc', 'RFC Chofer', '', [Validators.required, Validators.rfc_fisica], 6),
      Form.Field('text', 'chofer_calle', 'Calle', '', [Validators.required], 6),
      Form.Field('text', 'chofer_numero', 'Numero Exterior', '', [Validators.required], 6),
      Form.Field('autocomplete-async-cp', 'chofer_codigo_postal', 'Codigo Postal', '', [Validators.required], 6, [], [], [], false, false, '', 'search/codigo-postal'),
      Form.Field('select', 'chofer_id_colonia', 'Colonia', '', [Validators.required], 6),
      Form.Section("Camion"),
      Form.Field("autocomplete-async", "id_camion", "Clave camion", "", [Validators.required], 12, [], [], [], false, false, '', 'search/camion'),
      Form.Field("select", "id_permiso_sct", "Persmiso SCT", "", [Validators.required], 6),
      Form.Field("text", "camion_permiso_sct", "Numero Persmiso SCT", "", [Validators.required], 6),
      Form.Field("text", "camion_poliza_seguro", "Póliza Seguro", "", [Validators.required], 6),
      Form.Field("text", "camion_aseguradora", "Nombre Aseguradora", "", [Validators.required], 6),
      Form.Field("text", "camion_placas", "Placas Camión", "", [Validators.required], 6),
      Form.Field("number", "camion_modelo", "Modelo Camión", "", [Validators.required], 6),
      Form.Field("number", "PesoBrutoVehicular", "Peso Bruto Vehicular (toneladas)", "", [Validators.required], 6),
      Form.Field("select", "id_configuracion_vehicular", "Config Vehicular", "", [Validators.required], 6),
    ], [], `Datos Carta Porte Embarque #${this.idEmbarque}`)
  };

  componentDidMount() {
    if (this.idEmbarque && !isNaN(this.idEmbarque)) {
      this.FillForm().then(() => {
        this.LoadPreds(this.idEmbarque).then(d => {
          this.setState({ loadingData: false, loading: false });
        }).catch(() => {
          this.setState({ loadingError: 'Error al cargar', loadingData: false });
        })
      }
      ).catch(() => {
        this.setState({ loading: false, loadingData: false });
      })
    } else {
      this.setState({ loadingError: 'Error al cargar el Formulario', loadingData: false });
    }
  };

  FillForm = async () => {
    let params = {};
    if (this.idEmbarque) { params.e = this.idEmbarque }
    try {
      const Res = await Http.get(`embarque/salida/form?${objectAsParams(params)}`);
      if (Res.error) return;
      const { FormData } = this.state;
      const { configAutotransportes = [], tipos_permiso = [], camiones = [], choferes = [] } = Res.data;
      let newForm = { ...FormData };
      newForm = Form.FieldOptions(newForm, 'id_configuracion_vehicular', configAutotransportes, 'id', 'descripcion');
      newForm = Form.FieldOptions(newForm, 'id_permiso_sct', tipos_permiso, 'id', 'descripcion');
      newForm = Form.FieldOptions(newForm, 'id_chofer', choferes, 'Value', 'Label');
      newForm = Form.FieldOptions(newForm, 'id_camion', camiones, 'Value', 'Label');

      this.setState({ FormData: newForm });
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar el Formulario' })
    }
  };

  LoadPreds = async (predId = null) => {
    let id = this.props.idEmbarque;
    let { FormData } = this.state;
    let newForm = { ...FormData };
    try {
      let Res = await Http.get(`embarque/one/${id}`);
      if (!Res.error) {
        const { data } = Res;

        let choferInfo = newForm.Fields.find(f => f.Name === 'id_chofer')
        let camionInfo = newForm.Fields.find(f => f.Name === 'id_camion')
        choferInfo = choferInfo.Options.find(o => o.Value === data.id_chofer)
        camionInfo = camionInfo.Options.find(o => o.Value === data.id_camion)
        if (choferInfo) {
          data.chofer_numero_licencia = choferInfo.chofer_numero_licencia;
          data.chofer_rfc = choferInfo.chofer_rfc;
          data.chofer_id_colonia = choferInfo.chofer_id_colonia;
          data.chofer_calle = choferInfo.chofer_calle;
          data.chofer_numero = choferInfo.chofer_numero;
          data.chofer_codigo_postal = choferInfo.codigo_postal;
          newForm = Form.FieldOptions(newForm, 'chofer_codigo_postal', [{ Value: choferInfo.codigo_postal, Label: choferInfo.codigo_postal }], 'Value', 'Label');
          data.chofer_id_colonia = choferInfo.chofer_id_colonia;
          if (choferInfo.colonias) {
            newForm.Fields = newForm.Fields.map(f => {
              if (f.Name === 'chofer_id_colonia') {
                f.Options = choferInfo.colonias;
              }
              return { ...f };
            })
          }
        }
        if (camionInfo) {
          data.id_permiso_sct = camionInfo.id_permiso_sct || '';
          data.camion_permiso_sct = camionInfo.camion_permiso_sct || '';
          data.camion_poliza_seguro = camionInfo.camion_poliza_seguro || '';
          data.camion_aseguradora = camionInfo.camion_aseguradora || '';
          data.camion_placas = camionInfo.camion_placas || '';
          data.camion_modelo = camionInfo.camion_modelo || '';
          data.PesoBrutoVehicular = camionInfo.PesoBrutoVehicular || '';
          data.id_configuracion_vehicular = camionInfo.id_configuracion_vehicular || '';
        }

        this.setState({
          FormData: Form.Patch(newForm, data, true),
          status: data.status,
          loading: false
        });
      } else {
        this.setState({ loadingError: 'Error al cargar informacion(1)', loadingData: false });
      }
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    let vals = {};
    const { FormData } = this.state;
    for (const field of FormData.Fields) {
      vals[field.Name] = field.Value;
    }
    let valid = Form.ValidateForm(FormData);
    if (valid !== true) {
      this.setState({
        loadingSave: false,
      });
      return Toast.error(`Error en el campo '${valid.name}'`)
    }
    this.setState({ loading: true });
    vals.id = this.idEmbarque;
    try {
      let Res = await Http.post(`embarque/editar-carta`, { embarque: vals });
      if (!Res.error) {
        this.setState({ loading: false });
        return Toast.success(`Se guardo la informacion correctamente. Embarque #${this.idEmbarque}`)
      } else {
        this.setState({ loading: false });
        return Toast.error(Res.errMsg)
      }
    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false });
  };

  onSaveProducts = async (productos) => {
    this.setState({ loading: true });
    try {
      let Res = await Http.post(`embarque/productos/${this.idEmbarque}/save`, { productos });
      if (!Res.error) {
        this.setState({ loading: false });
        return Toast.success('Productos Guardados')
      } else {
        this.setState({ loading: false });
        return Toast.success(Res.errMsg)
      }
    } catch (error) {
      console.log(error)
    }
  };

  formChange = (form, field, type) => {
    let newForm = { ...form }
    if (field.Name === 'id_chofer' && type !== 'options') {
      let data = {}
      let choferInfo = field.Options.find(o => o.Value === field.Value) || {};
      data.chofer_numero_licencia = choferInfo.chofer_numero_licencia || '';
      data.chofer_rfc = choferInfo.chofer_rfc || '';
      data.chofer_id_colonia = choferInfo.chofer_id_colonia || '';
      data.chofer_calle = choferInfo.chofer_calle || '';
      data.chofer_numero = choferInfo.chofer_numero || '';
      data.chofer_codigo_postal = choferInfo.codigo_postal || '';
      data.chofer_id_colonia = choferInfo.chofer_id_colonia || '';
      if (choferInfo.colonias) {
        newForm.Fields = newForm.Fields.map(f => {
          if (f.Name === 'chofer_id_colonia') {
            f.Options = choferInfo.colonias;
          }
          return { ...f };
        })
      }

      newForm = Form.Patch(newForm, data, true);
    } else if (field.Name === 'chofer_codigo_postal' && type !== 'options') {
      newForm.Fields = newForm.Fields.map(f => {
        if (f.Name === 'chofer_id_colonia') {
          let colonias = field.Options.find(f => f.Value === field.Value) || {};
          colonias = colonias.colonias || [];
          f.Options = [...colonias]
          f.Value = '';
        }
        return { ...f }
      });
    } else if (field.Name === 'id_camion' && type !== 'options') {
      let data = {}
      let camionInfo = field.Options.find(o => o.Value === field.Value) || {};
      data.id_permiso_sct = camionInfo.id_permiso_sct || '';
      data.camion_permiso_sct = camionInfo.camion_permiso_sct || '';
      data.camion_poliza_seguro = camionInfo.camion_poliza_seguro || '';
      data.camion_aseguradora = camionInfo.camion_aseguradora || '';
      data.camion_placas = camionInfo.camion_placas || '';
      data.camion_modelo = camionInfo.camion_modelo || '';
      data.PesoBrutoVehicular = camionInfo.PesoBrutoVehicular || '';
      data.id_configuracion_vehicular = camionInfo.id_configuracion_vehicular || '';

      newForm = Form.Patch(newForm, data, true);
    }
    this.setState({ FormData: newForm });
  };

  render() {
    const {
      loading = false,
      loadingData,
      loadingError,
      FormData,
    } = this.state;

    if (loadingData) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <CircularProgress size={"50px"} color="primary" />
        <div><h3>Cargando...</h3></div>
      </div>
    }

    if (loadingError) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <h3>{loadingError}</h3>
      </div>
    }
    return (
      <div>
        <DynamicForm
          form={FormData}
          formChange={this.formChange}
          onSubmit={this.onSubmit}
        />
        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end'
        }} >
          <SubirProductos
            onChange={this.onSaveProducts}
          />
        </div>
        {
          (!loading && this.idEmbarque) ?
            <TablaGuiasEmbarque idembarque={this.idEmbarque} />
            : <CircularProgress color="secondary" size={20} />
        }
        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 10,
        }} >
          <Button
            onClick={this.props.onClose}
            variant='contained'
            disabled={loading}
            color='secondary'>
            Cancelar
          </Button>
          <Button
            variant='contained'
            disabled={loading}
            onClick={this.onSubmit}
            style={{ marginRight: 10 }}
            color='primary'>
            {loading && <CircularProgress color="secondary" size={20} />}
            {`Guardar Datos Embarque #${this.idEmbarque}`}
          </Button>
        </div>
      </div>
    )
  }
}

export default withRouter(EmbarqueCartaPorteDatos)
